import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App as AntdApp } from "antd";
import { ThemeProvider } from "@/hooks/useTheme";
import { GlassConfigProvider } from "@/hooks/useGlassTheme";
import { AuthProvider } from "@/hooks/useAuth";
import App from "./App";
import "./styles/glass.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ThemeProvider>
      <GlassConfigProvider>
        <AntdApp>
          <BrowserRouter>
            <AuthProvider>
              <App />
            </AuthProvider>
          </BrowserRouter>
        </AntdApp>
      </GlassConfigProvider>
    </ThemeProvider>
  </React.StrictMode>,
);
